import { CollectionGrid } from "@/components/Collections";

interface CollectionsTabProps {
  userId: string;
  isOwnProfile?: boolean;
}

export function CollectionsTab({ userId, isOwnProfile = false }: CollectionsTabProps) {
  return (
    <div className="space-y-4">
      <CollectionGrid userId={userId} isOwnProfile={isOwnProfile} />
    </div>
  );
}
